<template>
  <div class="arcadi-page arcadi-transfer">
    <div class="arcadi-card">
      <div class="flex arcadi-card__title">
        {{ $t("buy_dollars_page.show_title") }}
        <img
          :src="images.order"
          class="inline align-middle ml-3"
          style="min-width: 40px; max-width: 40px"
        />
      </div>
      <div>
        <div
          class="flex flex-col justify-center mb-6 p-2 transfer-amount-container-body transfer-amount-container-result"
        >
          <div class="flex items-center mb-1">
            <div class="px-4">
              <img
                :src="sourceImagePath"
                class="inline align-middle flag-style"
                style="min-width: 34px; max-width: 34px"
              />
            </div>
            <div class="flex-1 min-w-0">
              <span>{{ payMessage }}</span>
              <format-amount class="order-detail-amount" variant="primary"
                :amount="Number(order.source_amount)" :currency="order.source_amount_currency"
                :maximumFractionDigits="order.source_amount_currency === 'CLP' ? 0 : 2"
                :minimumFractionDigits="order.source_amount_currency === 'CLP' ? 0 : 2" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex flex-col justify-center mb-6 p-2 transfer-amount-container-body transfer-amount-container-body-green transfer-amount-container-result"
      >
        <div class="flex items-center mb-1">
          <div class="px-4">
            <img
              :src="coinImage"
              class="inline align-middle flag-style"
              style="min-width: 34px; max-width: 34px"
            />
          </div>
          <div class="flex-1 min-w-0">
            <span>{{ receiveMessage }}</span>
            <format-amount class="order-detail-amount" variant="primary"
              :amount="Number(order.destination_amount)" :currency="order.destination_amount_currency"
              :maximumFractionDigits="order.destination_amount_currency === 'CLP' ? 0 : 2"
              :minimumFractionDigits="order.destination_amount_currency === 'CLP' ? 0 : 2" />
          </div>
        </div>
      </div>
      <div class="card-preferences card-preferences__notice mt-8" role="note">
        <span class="material-icons-sharp" aria-hidden="true">info</span>
        <div>{{ buyDollarsMessage }}</div>
      </div>
      <div>
        <div class="order-form__info-container space-y-2">
          <div class="order-form__info">
            <span>{{ $t("buy_dollars_page.exchange_rate") }}:</span>
            <span v-if="Number(order.rate) > 1" class="flex items-center whitespace-nowrap">
              1 {{ order.source_amount_currency }} =
              <format-amount :amount="exchangeRateFeeles() || 0" :currency="order.destination_amount_currency"
                :maximumFractionDigits="2" :minimumFractionDigits="2" />
            </span>
            <span v-else class="flex items-center whitespace-nowrap">
              1 {{ order.destination_amount_currency }} =
              <format-amount :amount="1 / (exchangeRateFeeles() || 1)" :currency="order.source_amount_currency"
                :maximumFractionDigits="2" :minimumFractionDigits="2" />
            </span>
          </div>
          <hr class="w-full text-gray-10% mb-2">
          <div class="order-form__info">
            <span>{{ $t("buy_dollars_page.commission") }}:</span>
            <span class="whitespace-nowrap">
              <format-amount :amount="commission()" :currency="order.source_amount_currency"
                :maximumFractionDigits="2" :minimumFractionDigits="2" />
            </span>
          </div>
        </div>
        <div class="flex justify-between font-footer">
          <div>
            {{ new Date(order.created_at).toLocaleDateString() }}
          </div>
          <div class="whitespace-nowrap">Id:&nbsp;{{ order.id }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormatAmount from "../amount/format-amount.vue";

import USDTCoin from "../../../../assets/images/coin_flags/USDT.svg";

export default {
  components: { FormatAmount },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      images: {
        order: "/images/Menu-ComprarDolares.svg"
      }
    };
  },
  computed: {
    payMessage() {
      const message = {
        pending: this.$t("buy_dollars_page.pay_pending"),
        assigned: this.$t("buy_dollars_page.pay_pending"),
        executed: this.$t("buy_dollars_page.pay_executed"),
        other: this.$t("buy_dollars_page.pay_failed")
      };
      return message[this.order.state] || message.other;
    },
    receiveMessage() {
      const message = {
        pending: this.$t("buy_dollars_page.will_recieve"),
        assigned: this.$t("buy_dollars_page.will_recieve"),
        executed: this.$t("buy_dollars_page.executed"),
        other: this.$t("buy_dollars_page.failed")
      };
      return message[this.order.state] || message.other;
    },
    buyDollarsMessage() {
      const currency = this.order.destination_amount_currency === 'USDT'
        ? 'tether' : this.order.destination_amount_currency;
      const ticker = this.order.destination_amount_currency === 'USDT' ? ' (USDT)' : '';
      const message = {
        pending: this.$t("buy_dollars_page.buy_dollars_pending", { currency, ticker }),
        assigned: this.$t("buy_dollars_page.buy_dollars_pending", { currency, ticker }),
        executed: this.$t("buy_dollars_page.buy_dollars_executed", { currency, ticker }),
        other: this.$t("buy_dollars_page.buy_dollars_failed", { currency, ticker })
      };
      return message[this.order.state] || message.other;
    },
    coinImage() {
      const image = {
        USDT: USDTCoin,
        USDC: USDTCoin
      };
      return image[this.order.destination_amount_currency] || image.USDT;
    },
    sourceImagePath() {
      // Had to do this hack to avoid using a require statement with a dynamic string which it's not supported by vite
      const flags = import.meta.glob('../../../../assets/images/coin_flags/*.svg', { eager: true, as: 'url' });
      const flagPath = flags[`../../../../assets/images/coin_flags/${this.order.source_amount_currency}.svg`];
      return flagPath;
    }
  },
  mounted() {
    console.log(this.order);
  },
  methods: {
    commission() {
      return this.order.destination_amount > 0
        ? this.order.source_amount -
            this.order.source_amount * (1 - this.percentageCommission())
        : 0;
    },
    percentageCommission() {
      return this.order.fee;
    },
    exchangeRateFeeles() {
      return this.order.rate / (1 - this.percentageCommission());
    }
  }
};
</script>
<style scoped>
.order-detail-amount {
  padding-inline: 0;
  flex-wrap: wrap;
}

.transfer-amount-container-body {
  border-radius: 27px;
  border-left: 6px solid #611de9;
  background: #f9f9f9;
  height: 77px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.transfer-amount-container-result {
  min-height: 100px;
  height: auto;
}

.transfer-amount-container-body-green {
  border-left: 6px solid #ccff00;
}

.font-footer {
  color: #999;
}

</style>
